module.exports = __webpack_public_path__ + "static/media/assessment.b21ffe83.svg";